import React, { useRef } from 'react';
import './FloatingLabelInput.css';

const FloatingLabelInput = ({
  type = 'text' || 'select' || 'textarea' || 'date' || 'time' || 'number' || 'email' || 'password' || 'file' ,
  name,
  label,
  value,
  onChange,
  required = false,
  icon = null,
  options = []
}) => {

  const inputRef = useRef(null);

  const handleWrapperClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker?.();
      inputRef.current.focus();
    }
  };


  return (
    <div className="custom-floating-label custom-floating-label--filled" onClick={handleWrapperClick}>
      <input
        type={type}
        name={name}
        id={name}
        ref={inputRef}
        value={value}
        onChange={onChange}
        required={required}
        className={`custom-floating-label__input mt-text-input ${type === "text" ? "mt-text-input" : ""}`}
      />
      <label htmlFor={name} className="custom-floating-label__label">{label}</label>
      {icon && <span className="custom-floating-label__icon">{icon}</span>}
    </div>
  );
};

export default FloatingLabelInput;
